import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';

import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './ACCPBossScreenStyles';
import ACCPBossForm from 'app/components/ACCPBossForm';
import ACCPBossTableContainer from 'app/containers/ACCPBossTableContainer';

import { useDispatch } from 'react-redux';
import {  accpBossClear } from 'app/actions/ACCPBossActions';

export default function ACCPBossScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`  });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [filter, setFilter] = useState([]);
    const [visibleForm, isVisibleForm] = useState(false)
    const [idResponsible, setIdResponsible] = useState([]);
    const [FiltroNombre, setFiltroNombre] = useState([]);

    useEffect(() => {
        return () => {
            dispatch(accpBossClear());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header='Jefe(es) de AC y CP' isCommunicationStatus={false}/>
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text="Catálogo de Jefe(es) de AC y CP"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <ACCPBossForm idResponsible={idResponsible} setIdResponsible={setIdResponsible} visibleForm={visibleForm} isVisibleForm={isVisibleForm}  filter={filter} setFilter={setFilter} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} FiltroNombre={FiltroNombre} setFiltroNombre={setFiltroNombre}/>
                    <div style={styles.baseVerticalMargin}>
                        <ACCPBossTableContainer setIdResponsible={setIdResponsible} isVisibleForm={isVisibleForm} classes={classes} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData} setFiltroNombre={setFiltroNombre} FiltroNombre={FiltroNombre}>
                            {(params) => {
                                return (
                                    <div>
                                        <Table
                                            loading={params.isLoading}
                                            rowKey={item => String(item.employeeId)}
                                            columns={params.cols}
                                            dataSource={params.accpBoss}
                                            onChange={params.handleTableChange}
                                            pagination={pagination}
                                            //scroll={{ y: 700, x: "min-content" }}
                                            scroll={{ x: 'min-content', y: (height - 395) }}
                                            //size={"small"}
                                        />
                                    </div>
                                )
                            }}
                        </ACCPBossTableContainer>
                    </div>
                </Paper>


                </div>
            </div>
         )
}